(function ( root, factory ) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
            'jquery'
        ], factory );
    } else if ( typeof exports === 'object' ) {
        // Node, CommonJS-like
        module.exports = factory(
            require( 'jquery' )
        );
    } else {
        // Browser globals (root is window)
        root.TokenHelpers = factory(
            root.jQuery
        );
    }

})( this, function ( $ ) {

    /**
     * Helper functions for replacing track prop tokens.
     */
    var TokenHelpers = {
        // GENERIC.

        'SITE_TRAFFIC': function ( screenData ) {
            return this.pageConfig.siteTraffic || '[Site traffic - unavailable]';
        },
        'SITE_LANG_LOCALE': function ( screenData ) {
            return this.pageConfig.langLocale || '[Lang locale - unavailable]';
        },
        'TEAM_ABBREV': function ( screenData ) {
            return this.pageConfig.teamAbbrev || '[Team - unavailable]';
        },

        // GAMEDAY.

        'GAMEDAY_GAME_ID': function ( screenData ) {
            return undefined;
        },
        'GAMEDAY_GAME_PK': function ( screenData ) {
            return ( ( screenData.dynamicVars && screenData.dynamicVars.game ) ? screenData.dynamicVars.game.gamePk : screenData.meta.game_pk ) || 'none';
        },

        // MEDIA.

        'MEDIA_IPID': function ( screenData ) {
            // TODO - This is wrong, should be 'ipid' not 'content_id'. Update analytics.html
            //return window.adobeAnalytics.contextData['media.ipid'];
            return screenData.player.clip.content_id;
        },
        'MEDIA_PLAYER_FORMAT': function ( screenData ) {
            return screenData.player.toString();
        },
        'MEDIA_PLAYER_VERSION': function ( screenData ) {
            var versionName;
            var playerType = screenData.player.toString();

            switch ( playerType ) {
                case 'MultiViewFlashPlayer':
                case 'FlashPlayer':
                    versionName = screenData.config.flash ? ( screenData.config.flash.name + '_' + screenData.config.flash.release ) : 'fvp';
                    break;
                case 'HTML5Player':
                    versionName = 'HTML5';
                    break;
                case 'DashPlayer':
                    versionName = 'HTML5:DashPlayer';
                    break;
                case 'PrimetimePlayer':
                    versionName = 'HTML5:PrimetimePlayer';
                    break;
                default:
                    versionName = 'Player version not found';
            }

            return versionName;
        },
        'MEDIA_PLAYER_CONTEXT': function ( screenData ) {
            var playerContext = this.pageConfig.playerContext || this.pageConfig.location;

            if ( !playerContext ) {
                playerContext = "Video Playback Page";
            }

            return playerContext;
        },
        'MEDIA_COMPONENT_LOCATION': function ( screenData ) {
            var location = '';
            var section  = this.pageConfig.section;

            if ( 'embed' === section ) {
                location = ( this.pageConfig.playerContext ) ? this.pageConfig.playerContext : this.pageConfig.location;
                location = ( location ) ? location : 'Embedded Player';
            } else if ( 'vpp' === section ) {
                location = 'Video Playback Page';
            } else if ( 'nhltv' === section ) {
                location = 'Media Player';
            }

            return location;
        },
        'MEDIA_STREAM_ID': function ( screenData ) {
            // TODO - the playbackScenario is not right.
            return screenData.clip.content_id + '|' + screenData.config.playbackScenario;
        },
        'MEDIA_STREAM_VIDEO': function ( screenData ) {
            var streamVideo = 'none';

            if ( Array.isArray( screenData.meta.keywordsDisplay ) ) {
                var keywords = $.map( screenData.meta.keywordsDisplay, function ( obj, i ) {
                    if ( obj && obj.displayName ) {
                        return obj.displayName;
                    }
                    return null;
                } );
                streamVideo = keywords.join( '|' );
            }

            return streamVideo;
        },
        'MEDIA_STREAM_PLAYER': function ( screenData ) {
            // TODO - window.databootstap.topic vs. window.databootstap.
            return this.pageConfig.topic ? this.pageConfig.topic.title : 'none';
        },
        'MEDIA_STREAM_TYPE': function ( screenData ) {
            var playback;

            if ( screenData.clip.isHighlight ) {
                playback = "VOD";
            } else if ( screenData.clip.isAudioOnly ) {
                playback = "Audio";
            } else if ( screenData.clip.isLive === true ) {
                playback = "Live";
            } else if ( screenData.clip.isLive === false ) {
                playback = "Archive";
            } else {
                playback = "VOD";
            }

            return playback;
        }

        // TODO - DYNAMIC WiretapApp
        //'INDEX': function ( screenData ) {
        //    //if ( value.match( /@INDEX_\w+@/ ) ) {
        //    var parent = ( trackObj.wire && trackObj.wire.parent ) ? trackObj.wire.parent : null;
        //    return setIndex( value, $el, parent );
        //},
        //'TEXT': function ( screenData ) {
        //    return setText( value, $el );
        //}
        //'TEAM_ABBREV': function ( screenData ) {
        //    replacement = appVars.teamAbbrev ? appVars.teamAbbrev : '[Team - unavailable]';
        //    value = value.replace( /@TEAM_ABBREV@/, replacement );
        //}
        //if ( value.match( /@SITE_TRAFFIC@/ ) ) {
        //    replacement = appVars.siteTraffic ? appVars.siteTraffic : '[Site traffic - unavailable]';
        //    value = value.replace( /@SITE_TRAFFIC@/, replacement );
        //}
        //if ( value.match( /@SITE_NAME@/ ) ) {
        //    replacement = appVars.teamDisplay ? appVars.teamDisplay : 'National Hockey League';
        //    value = value.replace( /@SITE_NAME@/, replacement );
        //}
        //if ( value.match( /@MEDIA_SPONSOR@/ ) ) {
        //    replacement = 'NHL';
        //    value = value.replace( /@MEDIA_SPONSOR@/, replacement );
        //}
        //if ( value.match( /@LANG_LOCALE@/ ) ) {
        //    replacement = appVars.langLocale ? appVars.langLocale : '[Lang locale - unavailable]';
        //    value = value.replace( /@LANG_LOCALE@/, replacement );
        //}
    };

    /**
     * Set variable with the text content of an element or parent.
     * @param $el       The active DOM element.
     * @param parent    The parent or grandparent element.
     */
    function setText( $el, parent ) {
        var text = (parent) ? $el.parents( parent.s ).text() : $el.text();

        return text.trim().replace( /\s+/g, ' ' );
    }

    /**
     * Set variable with the index number of an element or parent.
     * @param value     The tracking value.
     * @param $el       The active DOM element.
     * @param zeroIndex Start at 0 or 1.
     * @param parent    The parent or grandparent element.
     */
    function setIndex( value, $el, parent, zeroIndex ) {
        var index;
        var offset;

        if ( value.match( /@INDEX_\d+_PARENT@/ ) && parent ) {
            index = $el.parents( parent.s ).index();
        } else {
            index = $el.index();
        }

        if ( value.match( /@INDEX_0/ ) ) {
            offset = 0;
        } else if ( value.match(/@INDEX_1/) ) {
            offset = 1;
        }

        // TODO - support the case with multiple unique replacements within a single prop value.
        //return value.replace( /@INDEX_\w+@/g, index + offset );
        return index + offset;
    }


    return TokenHelpers;
} );
